import React, { Fragment } from 'react';
import {Card} from "antd";
import {compose} from "redux";
import AnnotationForm from './AnnotationForm';
import { MARGIN_MD } from '../../../../../styles/constants';


const AnnotationsCard = ({
    title,
    annotations,
    onChange,
  }) =>
    <Card
      type="inner"
      title={title}
      style={{marginBottom: MARGIN_MD}}
    >
      <Fragment>
        {
          (annotations || []).map(({label, annotation, annotationName}, key) => 
            <AnnotationForm 
              key={key}
              label={label}
              value={annotation}
              name={annotationName}
              onChange={onChange}
            />
          )
        }
      </Fragment>
    </Card>

  export default compose(
  )(AnnotationsCard);
